// getItem :: String -> Effect (Nullable String)
export function getItem(key) {
  return function () {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn(
        "localStorageNoFallback: Error getting item " + key + ": " + e
      );
      return null;
    }
  };
}

// setItem :: String -> String -> Effect Unit
export function setItem(key) {
  return function (value) {
    return function () {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        console.warn(
          "localStorageNoFallback: Error setting item " + key + ": " + e
        );
      }
    };
  };
}
